import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerPostingComponent } from './dealer-posting.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { CustomerRentComponent } from '../customer/customer-rent/customer-rent.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { ProviderPostingComponent } from '../provider/provider-posting/provider-posting.component';


const routes: Routes = [
  { path: '', component: DealerPostingComponent,
    children: [
           
      { path: 'to-process', canActivate: [AuthGuard], component: ProviderPostingComponent, data: { transactionStages: [ TransactionStage.PENDING ] }}, 
      { path: 'processed', canActivate: [AuthGuard], component: ProviderPostingComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }},
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerPostingRoutingModule { }
